import { BoxV2 as Box, Flex } from 'portal-commons';
import { FunctionComponent, ReactNode } from 'react';

interface FormTitleProps {
  title: string;
  description: ReactNode;
}

const FormTitle: FunctionComponent<FormTitleProps> = ({
  title,
  description,
}) => (
  <Flex
    sx={{
      flexDirection: 'column',
      gap: 'm',
      width: '100%',
      color: 't.black90',
      fontWeight: 400,
      lineHeight: 'normal',
      whiteSpace: 'pre-wrap',
    }}
  >
    <Box sx={{ fontSize: 'H600' }}>{title}</Box>
    <Box sx={{ fontSize: 'H400' }}>{description}</Box>
  </Flex>
);

export default FormTitle;
